import * as React from 'react'

import { DateTextField } from 'main/ui'
import { Container, Label } from './ChildFields.styles'
import { FieldGroupContainer } from './styles'

interface IData {
  birthday: string
  desiredEnrollmentDate: string
}

interface IValidation {
  birthday?: string
  desiredEnrollmentDate?: string
}

interface IProps {
  data: IData
  index: number
  showLabel: boolean
  validationHints: IValidation
  onChange: (data: Partial<IData>) => void
}

function ChildFields(props: IProps) {
  const { data, index, showLabel, validationHints, onChange } = props

  return (
    <Container>
      {showLabel && <Label>Child {index + 1}</Label>}

      <FieldGroupContainer>
        <DateTextField
          label="Child's Birthday"
          placeholder="Enter child's birthday"
          value={data.birthday}
          onChange={birthday => onChange({ birthday })}
          validationHint={validationHints.birthday}
        />

        <DateTextField
          label="Desired Start Date"
          placeholder="Enter desired start date"
          value={data.desiredEnrollmentDate}
          onChange={desiredEnrollmentDate => onChange({ desiredEnrollmentDate })}
          validationHint={validationHints.desiredEnrollmentDate}
        />
      </FieldGroupContainer>
    </Container>
  )
}

export default React.memo(ChildFields)
